<template>
    <div v-if="calculations">
        <div class="step-title primary--text">
            <div>
                {{ title }}
            </div>
            <div v-if="navigation && calculations.length > 1" style="padding-top: 4px">
                <a class="mr-2" @click="onNavigate">
                    <i
                        class="fas fa-arrow-right  pa-0 ma-0 primary--text"
                        style="font-size: 15px;"
                    ></i>
                </a>
            </div>
        </div>

        <div :class="border ? 'lm-border pa-2' : ''">
            <v-row class="no-frame mt-n1" >
                <v-col
                    class="no-frame pl-0 pr-2 pt-0"
                    style="border-top-left-radius: 5px; border-top-right-radius: 5px;"
                >
                    <f-read-only-field
                        :label       = "$t('invoice.price.original')"
                        :value       = "sumPriceOriginal"
                        :align-right = "true"
                        :collective  = "collective"
                        :filled      = "!collective"
                        dense
                    />
                </v-col>
                <v-col class="no-frame pl-2 pb-0 pt-0" >
                    <f-read-only-field
                        :label       = "$t('invoice.price.recommended')"
                        :value       = "sumPriceRecommended"
                        :align-right = "true"
                        :collective  = "collective"
                        :filled      = "!collective"
                        dense
                    />
                </v-col>
            </v-row>

            <v-row
                class="no-frame pt-0 pb-0"
                style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;border-top-right-radius: 5px;"
            >
                <v-col class="no-frame pl-0 pr-2">
                    <f-read-only-field
                        :label       = "$t('invoice.cost.material')"
                        :value       = "sumCostMaterial"
                        :align-right = "true"
                        :collective  = "collective"
                        :filled      = "!collective"
                        dense
                    />
                </v-col>
                <v-col class="no-frame pl-2 pb-0 pt-0">

                </v-col>
            </v-row>

            <v-row
                class="no-frame pt-0 pb-0"
                style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;border-top-right-radius: 5px;"
            >
                <v-col class="no-frame pl-0 pr-2">
                    <f-read-only-field
                        :label       = "$t('invoice.cost.wage')"
                        :value       = "sumCostWage"
                        :align-right = "true"
                        :collective  = "collective"
                        :filled      = "!collective"
                        dense
                    />
                </v-col>
                <v-col class="no-frame pl-2 pb-0 pt-0">

                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import Core from "@/modules/core/service/Core";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";

export default {
    name: "IncCalculationSum",
    components: {
        FReadOnlyField
    },
    props: {
        calculations: {
            required: true,
            type    : Array
        },
        navigation: {
            required: false,
            default: function () {
                return false
            }
        },

        collective: {

        },

        border: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },
    },

    computed: {
        sumCostMaterial () {
            if (!this.calculations) {
                return "";
            }

            let sum = 0;
            this.calculations.forEach(site => {
                sum = sum + site.costMaterial;
            });

            if (Number.isNaN(sum) === true) {
                return "";
            }

            return Core.format.money (sum);
        },

        title () {
            if (!this.calculations || this.calculations.length === 0) {
                return null;
            }

            return this.calculations.length > 1 ? "Gesamtkalkulation" : "Kalkulation Anlage " + (this.calculations[0] ? this.calculations[0].unit.fabricNo : '');
        },

        sumCostWage () {
            if (!this.calculations) {
                return "";
            }

            let sum = 0;
            this.calculations.forEach(site => {
                sum = sum + site.costWage;
            });

            if (Number.isNaN(sum) === true) {
                return "";
            }

            return Core.format.money (sum);
        },

        sumPriceOriginal () {
            if (!this.calculations) {
                return "";
            }

            let sum = 0;
            this.calculations.forEach(site => {
                sum = sum + site.priceOriginal;
            });

            if (Number.isNaN(sum) === true) {
                return "";
            }

            return Core.format.money (sum);
        },

        sumPriceRecommended () {
            if (!this.calculations) {
                return "";
            }

            let sum = 0;
            this.calculations.forEach(site => {
                sum = sum + site.priceRecommended;
            });

            if (Number.isNaN(sum) === true) {
                return "";
            }

            return Core.format.money (sum);
        },
    },

    methods: {
        onNavigate () {
            this.$emit("navigate");
        }
    }
}
</script>

<style scoped>

.price-background {
    padding-bottom: 8px;
    padding-left: 5px;
    background-color: #f5f5f5;
}

</style>